import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { hasValidToken, login, refresh, setToken as _setToken, timeUntilRefresh } from "../api";
import Login from "./Login";

interface Props {
	children: React.ReactElement;
}

function useSetToken() {
	const [, setDummy] = useState({});
	return (token: string) => {
		_setToken(token);
		setDummy({});
	};
}

const AuthWall: React.FC<Props> = ({ children }) => {
	const setToken = useSetToken();

	const refreshHandle = useRef<NodeJS.Timeout>();
	const refreshToken = async () => {
		try {
			const res = await refresh();
			console.log("res", res);
			setToken(res);
		} catch (e) {
			console.error(e);
			setToken("");
		}
	};

	useEffect(() => {
		if (!hasValidToken()) {
			setToken("");
		}
	}, [hasValidToken()]);

	useEffect(() => {
		if (hasValidToken()) {
			refreshToken();
		}
	}, []);

	useEffect(() => {
		if (refreshHandle.current) {
			clearTimeout(refreshHandle.current);
		}
		if (hasValidToken()) {
			refreshHandle.current = setTimeout(refreshToken, timeUntilRefresh());
		}
	});

	if (!hasValidToken()) {
		return (
			<Login
				onSuccessfulLogin={(res: any) => {
					setToken(res.token);
				}}
				login={login}
				title="Backend"
			/>
		);
	}
	return children;
};

export default AuthWall;



// WEBPACK FOOTER //
// ./src/Backend/AuthWall.tsx